import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import Paging from "../components/includes/Paging";
import { ChangeSimpleDateString,LoginAfterCheckLogin } from "../../components/common/Common";

import fixIcon from "../../img/icon/icon-fix.png";
import fileIcon from "../../img/icon/icon-file.svg";
import "../../css/style.css";

//결제관리
const NoticeSet = () => {
  LoginAfterCheckLogin(2);  //로그인 상태 점검\
  const branch_idx = Number(localStorage.getItem('branch_idx'));

  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varNoticeFixList,setNoticeFixList] = useState([]);
  const [varNoticeList,setNoticeList] = useState([]);

  //페이지 조절 변수
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);

  //공지사항 목록 - 총 갯수와 상단 고정목록
  const GetNoticeInformation = async() => {
    const sendData = {branch_idx:branch_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_notices`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setNoticeFixList(datas.noticefix);
        setTotalCount(datas.totalcount);
      }
    });
  }

  //공지사항 목록 - 페이지별
  const GetNoticeList = async() => {
    const sendData = {branch_idx:branch_idx,pageNum:varPageNum,pageSize:varPageSize};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_notice_list`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        setNoticeList(datas.notices);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetNoticeInformation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //페이지가 바뀌면
  useEffect(() => {
    GetNoticeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum]);

  return (
    <div className="vh-content oper-wrap">
      <HeaderBranchTitle varPageTitle={'공지사항'} varBackString={'/Branch/Operating'}/>
      <div className="vh-content-body mt25">
				<div className="center-wrap">
          <div className="oper-notice-wrap">
            {/* 상부고정 */}
            {varNoticeFixList.length===0?null:
              <div className="top-fix">
                {varNoticeFixList.map((fixs,i)=>(
                  <Link key={'fixs_'+i} to={`/Branch/NoticeDetail/${fixs.board_idx}`}><img src={fixIcon} alt=""/>{fixs.board_title}</Link>
                ))}
              </div>
            }
            {/* 하부목록 */}
            <div className="notice-con">
							<ul>
              {varNoticeList.length===0?
                <li className="inq-box"><p className="inq-tit">공지사항 내역이 없습니다.</p></li>
              :varNoticeList.map((notices,i)=>(
                  <li key={'notices_'+i}>
                    <Link  to={`/Branch/NoticeDetail/${notices.board_idx}`}><img src={fixIcon} alt=""/>
                      <p>{notices.board_title}{notices.board_attach===0?null:<img src={fileIcon} alt=""/>}</p>
                      <span className="date">{ChangeSimpleDateString(notices.board_rdate)}</span>
                    </Link>
                  </li>
                ))}
              </ul>
              <Paging totalCount={varTotalCount} pageSize={varPageSize} curPage={varPageNum} setPage={setPageNum} />
            </div>
            <Link to={'/Branch/NoticeDetail/0'} className="btn-yes">등록</Link>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default NoticeSet;